import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_ROUTES, EMAIL_SUPER_ADMIN } from '@core/constants';
import { UserAiStore } from '@core/stores';

/**
 * Chặn route chỉ dành cho super_admin hệ thống. Backend không phát role 'super_admin',
 * nên nhận diện bằng email === EMAIL_SUPER_ADMIN (chuẩn hoá trim + lowercase, khớp logic
 * isSuperAdmin ở main-layout). Guard này chạy sau authGuard (route cha /admin) nên
 * currentUser đã được populate. Không phải super_admin → đẩy về trang not-found.
 */
export const superAdminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userAiStore = inject(UserAiStore);

  const email = userAiStore.currentUser()?.email?.trim().toLowerCase();
  const isSuperAdmin = !!email && email === EMAIL_SUPER_ADMIN.trim().toLowerCase();

  if (!isSuperAdmin) {
    void router.navigate([APP_ROUTES.ERROR]);
    return false;
  }
  return true;
};
